<template>
  <preloader-component v-if="loading" />
  <anketa-components
    v-if="!loading && anketa_need"
    :anketa="anketa"
    :contract_id="selected_contract['NEW_ID']"
  />
  <kid-prolongation-components
    v-else-if="!loading && kid_need"
    :contract_id="selected_contract['NEW_ID']"
  />
  <section v-if="!loading && !kid_need && !anketa_need" class="prolong">
    <h1>Заявление о пролонгации</h1>
    <table>
      <tr>
        <th>Договор</th>
        <th>Статус заявления</th>
      </tr>
      <tr v-for="(contract, key) in contracts" :key="key" @click="selectContract(key)">
        <td :class="key === selected_contract_key ? 'selected-input' : ''">
          <input
            :checked="key === selected_contract_key"
            :value="contract['NEW_ID']" :id="'used_contract_' + contract['NEW_ID']"
            type="radio"
          />
          {{ contract["NEW_SER"] + " " + contract["NEW_NUMBER"] + " от " + contract["NEW_DATE"] }}
        </td>
        <td :class="key === selected_contract_key ? 'selected-input' : ''">
          {{ contract["APP_STATUS"] }}
        </td>
      </tr>
    </table>
    <div id="payment_app" class="paymentApp">
      <div>
        Я,
        <span class="field paymentApp__fio">{{ fullNameComputed }}</span>
        <br />
        <span class="paymentApp__fio_label">(ФИО полностью)</span>
      </div>
      <span class="field">{{ `${selected_contract["BIRTH_DATE"]}г.` }}</span> рождения, паспорт серии
      <span class="field">{{ `${selected_contract["DOC_SERIAL"]} № ${selected_contract["DOC_NUMBER"]}` }}</span>, выдан
      <span class="field">{{ `${selected_contract["DOC_AUTH"]}, ${selected_contract["DOC_DATE"]}г.` }}</span>,
      являющийся Застрахованным по Договору
      <span class="field">{{ oldContractComputed }}</span>, прошу страховую сумму по риску
      <span v-if="selected_contract['HAS_INCOME'] === 'N'">Дожитие </span>
      <span v-if="selected_contract['HAS_INCOME'] === 'Y'">Дожитие до окончания срока страхования</span>в размере
      <div v-if="!costile && !costile1 && !costile2" style="display:inline">
        <span class="field">{{ selected_contract["OLD_AMOUNT"] }}</span> рублей (
        <span class="field">
          {{ selected_contract["OLD_AMOUNT_WORDS_TEXT"] }} {{ selected_contract["OLD_AMOUNT_WORDS_CURRENCY"] }}
        </span>)
        <div v-if="selected_contract['IS_PROFIT'] === 'Y'">
          и дополнительный инвестиционный доход в размере
          <span class="field">{{ selected_contract["OLD_PROFIT"] }}</span> рублей (
          <span class="field">
            {{ selected_contract["OLD_PROFIT_WORDS_TEXT"] }} {{ selected_contract["OLD_PROFIT_WORDS_CURRENCY"] }}
          </span>)
        </div>
        <div v-if="selected_contract['HAS_INCOME'] === 'Y'">
          и страховую сумму по риску Дожитие до определенной договором даты в размере
          <span class="field">{{ selected_contract["INCOME"] }}</span>рублей (
          <span class="field">
            {{ selected_contract["APP_INCOME_WORDS_TEXT"] }} {{ selected_contract["APP_INCOME_WORDS_CURRENCY"] }}
          </span>)
        </div>
        зачесть в счет премии на новый договор
        <span class="field">{{ newContractComputed }}</span> в размере
        <span class="field">{{ selected_contract["APP_FEE"] }}</span> рублей (
        <span class="field">
          {{ selected_contract["APP_FEE_WORDS_TEXT"] }}{{ selected_contract["APP_FEE_WORDS_CURRENCY"] }}
        </span>).
      </div>
      <div v-if="costile" style="display:inline">
        <span class="field">50 000 (пятьдесят тысяч)</span> долларов США и дополнительный инвестиционный доход <br>
        1. зачесть в счет премии на новый договор <span class="field">FL-DNA № 107954 от 01.03.2023</span>
        в размере <span class="field">200 000 (Двести тысяч)</span> рублей РФ<br>
        2. Остаток выплаты и дополнительный инвестиционный доход, перечислить на реквизиты: <br />
      </div>
      <div v-if="costile1" style="display:inline">
        <span class="field">12 416 (двенадцать тысяч четыреста шестнадцать)</span> долларов США
        и дополнительный инвестиционный доход <br>
        1. зачесть в счет премии на новый договор <span class="field">FL-ABA № 113935 от 19.09.2023</span>
        в размере <span class="field">1 150 000 (один миллион сто пятьдесят тысяч)</span> рублей РФ<br>
        2. Остаток выплаты и дополнительный инвестиционный доход, перечислить на реквизиты: <br />
      </div>
      <div v-if="costile2" style="display:inline">
        <span class="field">5 645 (пять тысяч шестьсот сорок пять)</span> долларов США
        и дополнительный инвестиционный доход <br>
        1. зачесть в счет премии на новый договор <span class="field">FL-AOM № 119353 от 22.12.2023</span>
        в размере <span class="field">100 000 (сто тысяч)</span> рублей РФ<br>
        2. Остаток выплаты и дополнительный инвестиционный доход, перечислить на реквизиты: <br />
      </div>
      <br />
      <div class="paymentApp__mobile">Мобильный телефон:
        <input
          v-model="selected_contract['PHONE']"
          tabindex="1"
          type="text"
          name="phone"
          placeholder="+7 (___) ___-__-__"
          v-mask="{
            mask: '+7 (F##) ###-##-##',
            tokens: {
              F: {
                pattern: /(?!8)\d/,
              },
              '#': { pattern: /\d/ },
            },
          }"
        />
        <br />
      </div>
      <div class="paymentApp__email">Адрес электронной почты:
        <input type="text" v-model="selected_contract['EMAIL']" />
      </div>
      <div
        v-if="selected_contract['SHOW_DETAILS'] === 'Y' &&
        (selected_contract['SIGNED'] === 'Y' || selected_contract['TO_SIGN'] === 'Y')"
        class="paymentApp__income"
      >
        <span>{{ incomeTextComputed }}<br /></span>
        <div class="paymentApp__income-field">
          <span class="fld">Банк получателя:</span>
          <span v-if="selected_contract['SIGNED'] === 'Y'">{{ selected_contract["BANK_NAME"] }}</span>
          <input v-if="selected_contract['TO_SIGN'] === 'Y'" type="text" v-model="selected_contract['BANK_NAME']" />
        </div>
        <div class="paymentApp__income-field">
          <span class="fld">Корр.счет:</span>
          <span v-if="selected_contract['SIGNED'] === 'Y'">{{ selected_contract["COR_ACC"] }}</span>
          <input v-if="selected_contract['TO_SIGN'] === 'Y'" type="text" v-model="selected_contract['COR_ACC']" />
        </div>
        <div class="paymentApp__income-field">
          <span class="fld">БИК:</span>
          <span v-if="selected_contract['SIGNED'] === 'Y'">{{ selected_contract["BIC"] }}</span>
          <input v-if="selected_contract['TO_SIGN'] === 'Y'" type="text" v-model="selected_contract['BIC']" />
        </div>
        <div class="paymentApp__income-field">
          <span class="fld">р/с:</span>
          <span v-if="selected_contract['SIGNED'] === 'Y'">{{ selected_contract["CUR_ACC"] }}</span>
          <input v-if="selected_contract['TO_SIGN'] === 'Y'" type="text" v-model="selected_contract['CUR_ACC']" />
        </div>
      </div>
      <div v-if="selected_contract['TO_SIGN'] === 'Y'">
        <div class="paymentApp__docs">
          <div class="paymentApp__doc">
            <span>Прикрепить копию паспорта (можно выбрать несколько файлов):</span>
            <input :multiple="true" @change="loadFiles($event,'passport')" type="file" />
            <div class="prol_tooltip">?
              <span>Копия разворота паспорта с фотографией и регистрацией</span>
            </div>
          </div>
          <div class="paymentApp__doc">
            <span>Иные документы (можно выбрать несколько файлов):</span>
            <input :multiple="true" @change="loadFiles($event,'other')" type="file" />
            <div class="prol_tooltip">?
              <span>Копия банковских реквизитов при наличии</span>
            </div>
          </div>
        </div>
        <div class="paymentApp__checkboxes">
          <div class="paymentApp__checkbox">
            <input v-model="active_correct" id="prolongation_checkCorrect" type="checkbox" value="" />
            <label for="prolongation_checkCorrect">Корректность данных подтверждаю</label>
          </div>
          <div class="paymentApp__checkbox">
            <input v-model="active_rules" id="prolongation_checkRules" type="checkbox" value="" />
            <label for="prolongation_checkRules" class="">Я подтверждаю достоверность всех сведений, указанных в
              <doc-preview-component
                :contract_id="selected_contract['NEW_ID']"
                text="Договоре инвестиционного страхования жизни"
                :link="loaded_prolongation_html"
                type="html"
                :index="0"
                @loadhtml="loadhtml"
              />
              ,
              <doc-preview-component
                :contract_id="selected_contract['NEW_ID']"
                text="декларации Застрахованного (раздел 7 настоящего Договора)"
                :link="loaded_prolongation_html"
                type="html"
                :index="1"
                @loadhtml="loadhtml"
              />
              .
              Все положения Договора, включая размер и порядок оплаты страховой премии, выплаты страховой и выкупной
              суммы,порядок расчета дополнительного инвестиционного дохода, включая риски, связанные с инвестированием
              средств инвестиционного фонда, порядок расторжения и изменения Договора, и другие условия мне понятны.
              Я ознакомлен и согласен с
              <doc-preview-component
                :contract_id="selected_contract['NEW_ID']"
                type="pdf"
                text="Правилами страхования"
                :link="selected_contract['RULES']"
                :index="2"
              />
              ,
              <doc-preview-component
                :contract_id="selected_contract['NEW_ID']"
                text="Информацией об условиях договора добровольного страхования"
                :link="loaded_prolongation_html"
                type="html"
                :index="3"
                @loadhtml="loadhtml"
              />
              и
              <doc-preview-component
                :contract_id="selected_contract['NEW_ID']"
                text="Памяткой к договору страхования"
                :link="loaded_prolongation_html"
                type="html"
                :index="4"
                @loadhtml="loadhtml"
              />
              .
            </label>
          </div>
          <div class="paymentApp__checkbox">
            <input v-model="active_fields" id="prolongation_checkFields" type="checkbox" value="" />
            <label for="prolongation_checkFields" class="prolongation_agreement">Выражаю свое согласие на
              <doc-preview-component
                :contract_id="selected_contract['NEW_ID']"
                text="обработку своих персональных данных"
                :link="loaded_prolongation_html"
                type="html"
                :index="5"
                @loadhtml="loadhtml"
              ></doc-preview-component>
            </label>
          </div>
          <div style="margin-top: 10px;">
            Для подписания договора страхования простой электронной подписью необходимо ввести код из СМС, который будет
            Вам направлен на указанный номер телефона
          </div>
          <sms-component
            :active="active_rules && active_correct && active_fields"
            :view="'prolongation'"
            :contract_id="selected_contract['NEW_ID']"
            :other_params="{
              bank_name: selected_contract['BANK_NAME'],
              cor_acc: selected_contract['COR_ACC'],
              bic: selected_contract['BIC'],
              cur_acc: selected_contract['CUR_ACC'],
              phone: selected_contract['PHONE'],
              email: selected_contract['EMAIL'],
              files: files,
            }"
            @signed="signed"
          />
        </div>
      </div>
      <a v-if="selected_contract['PAY_URL']" id="prolongation_pay" :href="selected_contract['PAY_URL']">Оплатить</a>
      <br />
      <span v-if="selected_contract['MAILED'] === 'Y'" class="prolongation_alert">
        Вам на почту отправлены договор и правила<br />
      </span>
      <div v-if="selected_contract['SIGNED'] === 'Y'">
        <a
          id="prolongation_link" href=""
          @click="$router.push({ name: 'contract', params: { id: selected_contract['NEW_ID'] }});"
        >
          Информация о договоре
        </a>
        <br />
        <a id="load_contract" :href="contract_link">Скачать договор</a>
      </div>
    </div>
  </section>
  <modal-component
    v-if="modal_data.active"
    :contract_id="selected_contract['NEW_ID']"
    :title="modal_data.title"
    :body="modal_data.body"
    :active="modal_data.active"
    :params="modal_data.data"
    type="prolongation"
  />
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import { url, b2burl } from "@/profile/composables/url";
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import SmsComponent from "@/profile/components/SmsComponent.vue";
import DocPreviewComponent from "@/profile/components/DocPreviewComponent.vue";
import ModalComponent from "@/profile/components/ModalComponent.vue";
import KidProlongationComponents from "@/profile/components/KidProlongationComponents.vue";
import AnketaComponents from "@/profile/components/AnketaComponents.vue";

export default {
  data: () => {
    return {
      kid_need: false,
      anketa_need: false,
      anketa: [],
      contract_link: "",
      contracts: [],
      selected_contract: {},
      active_rules: false,
      active_fields: false,
      active_correct: false,
      loaded_prolongation_html: undefined,
      costile: false,
      costile1: false,
      costile2: false,
      infoData: null,
      files: {
        passport: [],
        other: []
      },
      modal_data: {
        title: "",
        body: "",
        data: {},
        active: false
      },
      loading: true,
      selected_contract_key: 0
    };
  },
  directives: { mask },
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData();
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "fetchData"
  },
  computed: {
    fullNameComputed() {
      if (this.selected_contract["LAST_NAME"] && this.selected_contract["FIRST_NAME"] && this.selected_contract["MIDDLE_NAME"]) {
        return `${this.selected_contract["LAST_NAME"]} ${this.selected_contract["FIRST_NAME"]} ${this.selected_contract["MIDDLE_NAME"]}`;
      } else {
        return ``;
      }
    },
    oldContractComputed() {
      if (this.selected_contract["OLD_SER"] && this.selected_contract["OLD_NUMBER"] && this.selected_contract["OLD_DATE"]) {
        return `${this.selected_contract["OLD_SER"]} № ${this.selected_contract["OLD_NUMBER"]} от ${this.selected_contract["OLD_DATE"]}г.`;
      } else {
        return ``;
      }
    },
    newContractComputed() {
      if (this.selected_contract["NEW_SER"] && this.selected_contract["NEW_NUMBER"] && this.selected_contract["NEW_DATE"]) {
        return `${this.selected_contract["NEW_SER"]} № ${this.selected_contract["NEW_NUMBER"]} от ${this.selected_contract["NEW_DATE"]}г.`;
      } else {
        return ``;
      }
    },
    incomeTextComputed() {
      if (this.selected_contract["HAS_INCOME"] === "N") {
        return `Остаток суммы выплаты, в т.ч. сумму дополнительного инвестиционного дохода, при наличии, перечислить на реквизиты:`;
      } else {
        return `Остаток суммы выплаты перечислить на реквизиты:`;
      }
    }
  },
  methods: {
    loadhtml(value) {
      this.loaded_prolongation_html = value;
    },
    // send(params) {
    //   axios.post(url, {
    //     params: params,
    //     token: this.$myApp.token.get()
    //   });
    // },
    loadFiles(event, type) {
      this.files.passport = [];
      this.files.other = [];
      for (let i = 0; i < event.target.files.length; i++) {
        if (type === "passport") {
          this.getBase64(event.target.files[i]).then(
            data => this.files.passport.push({
              name: event.target.files[i].name,
              type: event.target.files[i].type,
              size: event.target.files[i].size,
              lastModified: event.target.files[i].lastModified,
              data: data
            }));
        } else {
          this.getBase64(event.target.files[i]).then(
            data => this.files.other.push({
              name: event.target.files[i].name,
              type: event.target.files[i].type,
              size: event.target.files[i].size,
              lastModified: event.target.files[i].lastModified,
              data: data
            }));
        }
      }
    },
    signed() {
      this.modal_data.title = "Договор успешно подписан!";
      this.modal_data.body = "Поздравляем, Вы успешно оформили договор!<br/>" +
        (this.selected_contract["EMAIL"] != null ? ("".concat(
          "На Ваш адрес ", this.selected_contract["EMAIL"], " будут направлены страховой полис, подписанный электронной подписью Страховщика, а так же памятки и правила страхования"
        )) : "");
      this.modal_data.active = true;
    },
    selectContract(key) {
      this.costile = false;
      this.costile1 = false;
      this.costile2 = false;
      this.selected_contract = this.contracts[key];
      if (this.selected_contract.KID_NEED === "Y") {
        this.kid_need = true;
      }
      if (this.selected_contract.need_anketa == "Y") {
        this.anketa_need = true;
        this.anketa = this.selected_contract.anketa;
      }
      this.selected_contract_key = key;
      this.contract_link = b2burl + this.selected_contract.SLUG + "/";
      if (this.selected_contract.NEW_NUMBER == "113935") {
        this.costile1 = true;
      }
      if (this.selected_contract.NEW_NUMBER == "119353") {
        this.costile2 = true;
      }
      if (this.selected_contract.NEW_NUMBER == "107954") {
        this.costile = true;
      }
    },
    fetchData() {
      let params = {
        command: "prolongation_dogovors",
        contract_id: this.id,
        token: this.$myApp.token.get()
      };
      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            $this.contracts = data.contracts;
            $this.selectContract($this.selected_contract_key);
            $this.selected_contract = data.contracts[$this.selected_contract_key];
            if ($this.selected_contract.KID_NEED === "Y") {
              $this.kid_need = true;
            }
            $this.contract_link = b2burl + $this.selected_contract.SLUG + "/";
            if ($this.selected_contract.NEW_NUMBER == "113935") {
              $this.costile1 = true;
            }
            if ($this.selected_contract.NEW_NUMBER == "119353") {
              $this.costile2 = true;
            }
            if ($this.selected_contract.NEW_NUMBER == "107954") {
              $this.costile = true;
            }
            $this.getContractDetails();
            $this.loading = false;
          }
        });
    },
    async getContractDetails() {
      // console.log(this.selected_contract.APP_ID);
      const api = await this.$api2.get({
        action: "get-contract-details",
        object: "cpa",
        agreement_id: this.selected_contract.APP_ID,
        contract_id: this.selected_contract.APP_ID,
        version_id: this.selected_contract.APP_ID,
        cover_id: this.selected_contract.APP_ID,
        document_id: this.selected_contract.APP_ID,
        token: this.$myApp.token.get()
      });
      // console.log(`АААААААА`, api);
      if (api.success) {
        this.infoData = api.data.details;
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  },
  components: {
    SmsComponent,
    PreloaderComponent,
    DocPreviewComponent,
    ModalComponent,
    KidProlongationComponents,
    AnketaComponents
  }
};
</script>

<style scoped>
.field {
  border-bottom: solid 1px #000000;
  font-size: 19px;
}

@media only screen and (max-width: 768px) {
  .field {
    font-size: 16px;
  }
}

#payment_app label > span.fld ~ input {
  background: #ffffdd;
}

#payment_app label > span.fld ~ input:focus {
  background: #ffffc4;
}

#prolongation_pay, #prolongation_link, #load_contract {
  width: 400px;
  float: right;
  margin: 0 0 0 -400px;
  padding: 10px;
  background: #0062cc;
  color: #FFFFFF;
  border: 2px solid #005cbf;
  outline: #0075D4;
  cursor: pointer;
  font: 700 20px SourceSansPro, sans-serif;
  border-radius: .3rem;
}

#prolongation_pay, #prolongation_link, #load_contract {
  float: none;
  margin: 0;
  /*display: none;*/
  width: 200px;
  line-height: 2.5em;
}

.prolongation_alert {
  color: red;
}

@media screen and (max-width: 768px) {
  #prolongation_pay, #prolongation_link, #load_contract {
    display: block;
  }
}
</style>

<!--<script setup>-->
<!--import modalComponent from "@/profile/components/ModalComponent.vue";-->
<!--</script>-->